import {Component, Input, OnInit} from '@angular/core';
import {IBService} from '../ib.service';
import {getTimeRemoveTimezoneOffset } from 'src/app/shared/utils/helper';
import { Constants } from 'src/app/shared/utils/constants';
@Component({
  selector: 'fx-campaign-list',
  templateUrl: './campaign-list.component.html',
  styleUrls: ['./campaign-list.component.sass']
})
export class CampaignListComponent implements OnInit {
  @Input() type;
  @Input()
  set userId(val) {
    if (val) {
      this._userId = val;
      this.getCampaignList(val);
    }
  }
  data: any[] = [];
  currency = 'jpy';
  startTime = null;
  endTime = null;
  _userId = null;
  constructor(
    private service: IBService
  ) { }

  ngOnInit(): void {
  }

  refresh():void {
    this.getCampaignList(this._userId)
    this.endTime = null;
    this.startTime = null;
  }

  search():void {
    let startTime = getTimeRemoveTimezoneOffset(this.startTime);
    let endTime = getTimeRemoveTimezoneOffset(this.endTime);
    if(this._userId && startTime && endTime){
      let params = {
        from_time: startTime,
        to_time: endTime
      }
      this.getCampaignList( this._userId, params);
    }
  }

  private getCampaignList(userId, params = {}): void {
    this.service.getCampaignListByUser(userId, params)
      .subscribe(res => {
        if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
            this.data = res.data[this.type];
        }
      });
  }

}
